export default class FadeIn {
  constructor({ section = document }) {
    this.section = section;
    this.init();
  }

  init() {
    const setMultipleAttributes = (el, attrs = {}) => {
      for (var key in attrs) {
        const val = typeof attrs[key] === "object"
          ? JSON.stringify(attrs[key])
          : attrs[key];
        el.setAttribute(key, val);
      }
    };

    const fadeInAttrs = {
      ["x-data"]: {
        fadeIn: false,
      },
      ["x-intersect.half"]: "fadeIn = true",
      [":class"]: "fadeIn && 'opacity-100'",
    };
    this.section.querySelectorAll(".fade-in").forEach((section) => {
      setMultipleAttributes(section, fadeInAttrs);
    });
  }
};
